import React from 'react'
import PropTypes from 'prop-types'

import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'
import CircularProgress from 'material-ui/CircularProgress'

const DialogHeader = ({ inProgress }) => {
  return (
    <div style={styles.header}>
      { inProgress ? 'Importing...' : 'Import completed' }
    </div>
  )
}

DialogHeader.propTypes = {
  inProgress: PropTypes.bool
}

const DialogFooter = ({ onOkClicked }) => (
  <div style={styles.footer}>
    <FlatButton
      key='ok'
      label='Ok'
      primary={true}
      onTouchTap={onOkClicked} />
  </div>
)

DialogFooter.propTypes = {
  onOkClicked: PropTypes.func.isRequired
}

const ImportedCalendarItem = ({ calendar }) => {
  return (
    <div style={styles.item}>
      <div style={styles.circle(calendar.backgroundColor)}></div>
      <div style={styles.summary}>{ calendar.summary }</div>
    </div>
  )
}

ImportedCalendarItem.propTypes = {
  calendar: PropTypes.object.isRequired
}

const DialogContent = ({ list, error }) => {
  return (
    <div style={styles.content}>
      { error
        ? <div style={styles.error}>{ error }</div>
        : (
          <div style={styles.success}>
            <div style={styles.infoTip}>Events from the following calendars have been imported to Fibo.</div>
            <div style={styles.listContainer}>
              { list.map(calendar => <ImportedCalendarItem key={calendar.id} calendar={calendar}/>) }
            </div>
            <div style={styles.infoTip}>You can now re-assign them to others on your team.</div>
          </div>
        )
      }
    </div>
  )
}

DialogContent.propTypes = {
  list: PropTypes.array, 
  error: PropTypes.string
}

const InProgressIndicator = () => {
  return (
    <div style={styles.progressIndicator}>
      <CircularProgress />
    </div>
  )
}

export default class ImportSummaryDialog extends React.Component {

  static propTypes = {
    open: PropTypes.bool,
    calendarsImportError: PropTypes.string,
    importedCalendarsList: PropTypes.array,
    onCloseRequested: PropTypes.func.isRequired
  }

  handleOkClicked = event => {
    event.preventDefault()
    this.props.onCloseRequested()
  }

  render() {
    const inProgress = !this.props.calendarsImportError && !this.props.importedCalendarsList
    return (
      <Dialog open={this.props.open}
        bodyStyle={styles.dialogBody}
        contentStyle={styles.dialogContent}>
        <DialogHeader inProgress={inProgress}/>
        { inProgress
          ? <InProgressIndicator />
          : <DialogContent
            error={this.props.calendarsImportError}
            list={this.props.importedCalendarsList}/>
        }
        <DialogFooter onOkClicked={this.handleOkClicked}/>
      </Dialog>
    )
  }

}

const styles = {

  dialogContent: {
    borderRadius: 2,
    // This is a hack as there is a bug in Dialog's definition to properly
    // apply the border radius.
    overflow: 'auto',
    width:360
  },

  dialogBody: {
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
    borderRadius: 2
  },

  content: {
    padding: 16
  },

  header: {
    padding: 16,
    borderRadius: 2,
    fontWeight: 500,
    fontFamily: 'Roboto',
    fontSize: 15,
    backgroundColor: '#f7f7f7',
    color: 'rgba(0, 0, 0, 0.71)',
    boxShadow: 'inset 0 1px 0 0 rgba(0, 0, 0, 0.05)'
  },

  footer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    padding: 16
  },

  success: {
    display: 'flex',
    flexDirection: 'column'
  },

  infoTip: {
    fontWeight: 400,
    fontFamily: 'Roboto',
    fontSize: 15
  },

  error: {
    color: '#f00',
    fontSize: 15,
    fontWeight: 400
  },

  progressIndicator: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    margin: 16
  },

  item: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 12
  },

  circle: backgroundColor => ({
    width: 18,
    height: 18,
    borderRadius: 9,
    backgroundColor
  }),

  summary: {
    color: '#9b9b9b',
    fontWeight: 300,
    fontSize: 13,
    fontFamily: 'Roboto',
    marginLeft: 12
  },

  listContainer: {
    marginTop: 22,
    marginBottom: 10
  }
  
}



// WEBPACK FOOTER //
// ./src/schedule/gcal/ImportSummaryDialog.js